import { render, staticRenderFns } from "./AccountProfileSettingsChangePassword.vue?vue&type=template&id=f63d0fb8&"
import script from "./AccountProfileSettingsChangePassword.vue?vue&type=script&lang=js&"
export * from "./AccountProfileSettingsChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports